import React from "react";
import * as Shared from "../components/CivicShared";

const {
  ArrowLeft,
  ArrowRight,
  CheckCircle2,
  FileText,
  Mail,
  MapPin,
  MessageSquare,
  Phone,
  ShieldCheck,
  Smartphone,
} = Shared;

function ContactPage({ onBack }) {
  const goTo = (path) => {
    window.location.href = path;
  };

  return (
    <div className="civic-site">
      <main className="contact-page">

        {/* HERO */}
        <section className="contact-hero">
          <div className="contact-hero-inner">

            <button className="simple-back" onClick={onBack}>
              <ArrowLeft size={17} />
              Back
            </button>

            <span className="eyebrow">
              VIJAYANAGAR CIVIC PORTAL
            </span>

            <h1>Contact Us</h1>

            <p>
              We are here to help residents with civic information, portal
              assistance, complaint tracking and other questions related to
              Vijayanagar.
            </p>

          </div>
        </section>


        {/* CONTACT INFORMATION */}
        <section className="contact-content">

          <div className="contact-intro">
            <span className="contact-label">
              GET IN TOUCH
            </span>

            <h2>
              How can we help you?
            </h2>

            <p>
              Whether you need help using the portal, want to report a civic
              issue, or simply have a question, you can reach us using the
              contact details below.
            </p>
          </div>


          <div className="contact-grid contact-grid-three">

            {/* EMAIL */}
            <article className="contact-card contact-card-featured">

              <div className="contact-icon">
                <Mail size={23} />
              </div>

              <span className="contact-label">
                EMAIL
              </span>

              <h2>
                Email Us
              </h2>

              <p>
                For general enquiries, portal assistance, civic information
                and other questions, send us an email.
              </p>

              <a
                className="contact-detail-link"
                href="mailto:admin@vijayanagar.org"
              >
                <Mail size={17} />
                admin@vijayanagar.org
              </a>

              <div className="contact-actions">
                <a
                  className="contact-button primary"
                  href="mailto:admin@vijayanagar.org"
                >
                  <Mail size={16} />
                  Send Email
                </a>
              </div>

            </article>


            {/* PHONE */}
            <article className="contact-card">

              <div className="contact-icon">
                <Phone size={23} />
              </div>

              <span className="contact-label">
                PHONE
              </span>

              <h2>
                Call Us
              </h2>

              <p>
                Speak with us directly if you need assistance or have a
                question about the Vijayanagar Civic Portal.
              </p>

              <div className="contact-phone-list">

                <a
                  className="contact-detail-link"
                  href="tel:+918550855030"
                >
                  <Phone size={17} />
                  8550 8550 30
                </a>

                <a
                  className="contact-detail-link"
                  href="tel:+919742893339"
                >
                  <Phone size={17} />
                  97428 93339
                </a>

              </div>

            </article>


            {/* LOCATION */}
            <article className="contact-card">

              <div className="contact-icon">
                <MapPin size={23} />
              </div>

              <span className="contact-label">
                LOCAL INFORMATION
              </span>

              <h2>
                Vijayanagar
              </h2>

              <p>
                Explore ward information, civic services and publicly
                available local information through the portal.
              </p>

              <div className="contact-detail-link contact-detail-static">
                <MapPin size={17} />
                Vijayanagar, Bengaluru
              </div>

              <div className="contact-actions">
                <button
                  className="contact-button"
                  onClick={() => goTo("/wards")}
                >
                  <MapPin size={16} />
                  Explore Wards
                  <ArrowRight size={16} />
                </button>
              </div>

            </article>

          </div>


          {/* PRIMARY ACTIONS */}
          <section className="contact-help-section">

            <div className="contact-help-content">

              <span className="contact-label">
                CIVIC ASSISTANCE
              </span>

              <h2>
                Need to report a civic issue?
              </h2>

              <p>
                The quickest way to get a civic issue recorded is to submit
                it through the portal. You can provide the location, ward,
                description and photographs of the issue and receive a
                tracking ID.
              </p>

              <div className="contact-help-actions">

                <button
                  className="contact-button primary large"
                  onClick={() => goTo("/report-issue")}
                >
                  <FileText size={17} />
                  Report an Issue
                  <ArrowRight size={17} />
                </button>

                <button
                  className="contact-button large"
                  onClick={() => goTo("/track-complaint")}
                >
                  <CheckCircle2 size={17} />
                  Track a Complaint
                </button>

              </div>

            </div>

            <div className="contact-help-icon">
              <MessageSquare size={48} />
            </div>

          </section>


          {/* HELP OPTIONS */}
          <section className="contact-options">

            <div className="contact-options-header">
              <span className="contact-label">
                QUICK HELP
              </span>

              <h2>
                Looking for something specific?
              </h2>
            </div>


            <div className="contact-options-grid">

              <button
                className="contact-option"
                onClick={() => goTo("/report-issue")}
              >
                <div className="contact-option-icon">
                  <FileText size={19} />
                </div>

                <div>
                  <strong>Report an Issue</strong>
                  <span>
                    Submit a new civic complaint
                  </span>
                </div>

                <ArrowRight size={17} />
              </button>


              <button
                className="contact-option"
                onClick={() => goTo("/track-complaint")}
              >
                <div className="contact-option-icon">
                  <CheckCircle2 size={19} />
                </div>

                <div>
                  <strong>Track Complaint</strong>
                  <span>
                    Check your complaint status
                  </span>
                </div>

                <ArrowRight size={17} />
              </button>


              <button
                className="contact-option"
                onClick={() => goTo("/wards")}
              >
                <div className="contact-option-icon">
                  <MapPin size={19} />
                </div>

                <div>
                  <strong>Explore Wards</strong>
                  <span>
                    View Vijayanagar ward information
                  </span>
                </div>

                <ArrowRight size={17} />
              </button>


              <button
                className="contact-option"
                onClick={() => goTo("/services")}
              >
                <div className="contact-option-icon">
                  <Smartphone size={19} />
                </div>

                <div>
                  <strong>Public Services</strong>
                  <span>
                    Find local civic services
                  </span>
                </div>

                <ArrowRight size={17} />
              </button>

            </div>

          </section>


          {/* SECURITY / COMPLAINT NOTE */}
          <div className="contact-note">

            <div className="contact-note-icon">
              <ShieldCheck size={20} />
            </div>

            <div>
              <strong>
                For complaint-related matters
              </strong>

              <p>
                Please submit civic issues through the Report Issue section
                whenever possible. This allows the issue to be recorded
                properly and provides a unique tracking ID so that its
                progress can be followed through the portal.
              </p>
            </div>

          </div>

        </section>

      </main>
    </div>
  );
}

export default ContactPage;